import React from 'react'
import BottomBar from '../../layouts/bottomBar/BottomBar'
import NavbarMobile from '../../layouts/navabrMobile/NavbarMobile'
import MobileGoldenAwards from '../../mobileView/goldenAwards/MobileGoldenAwards'

const MobGoldenAwards = () => {
  return (
    <div>
        <NavbarMobile />
        <MobileGoldenAwards />
        <BottomBar />
    </div>
  )
}

export default MobGoldenAwards
